import { createFileRoute } from '@tanstack/react-router';

import { VerifyCertificatePage } from '@/features/certifications/VerifyCertificatePage';

export const Route = createFileRoute('/verify/$code')({
  component: VerifyCertificatePage,
});
